(() => {
  if (window.DBTCardRowAlignmentInitialized) return;
  window.DBTCardRowAlignmentInitialized = true;

  const GRID_SELECTOR = '.product-grid';
  const ITEM_SELECTOR = ':scope > .grid__item';
  const MEDIA_SELECTOR = '.dbt-collection-card .card__inner';
  const MIXED_CLASS = 'dbt-row--mixed-media';
  const ROW_TOLERANCE = 4;
  const HEIGHT_DIFFERENCE_THRESHOLD = 8;

  let scheduledFrame = null;
  const observedGrids = new WeakSet();
  const resizeObserver =
    typeof ResizeObserver === 'function'
      ? new ResizeObserver(() => scheduleUpdate())
      : null;

  function scheduleUpdate() {
    if (scheduledFrame !== null) cancelAnimationFrame(scheduledFrame);
    scheduledFrame = requestAnimationFrame(() => {
      scheduledFrame = null;
      updateAllGrids();
    });
  }

  function groupItemsByRow(items) {
    const rows = [];

    items.forEach((item) => {
      const top = item.getBoundingClientRect().top;
      let row = rows.find((candidate) => Math.abs(candidate.top - top) <= ROW_TOLERANCE);

      if (!row) {
        row = { top, items: [] };
        rows.push(row);
      }

      row.items.push(item);
    });

    return rows;
  }

  function updateGrid(grid) {
    const items = Array.from(grid.querySelectorAll(ITEM_SELECTOR)).filter(
      (item) => item.getClientRects().length > 0
    );

    items.forEach((item) => item.classList.remove(MIXED_CLASS));

    groupItemsByRow(items).forEach((row) => {
      if (row.items.length < 2) return;

      const mediaHeights = row.items
        .map((item) => item.querySelector(MEDIA_SELECTOR))
        .filter(Boolean)
        .map((media) => media.getBoundingClientRect().height)
        .filter((height) => height > 0);

      if (mediaHeights.length < 2) return;

      const shortest = Math.min(...mediaHeights);
      const tallest = Math.max(...mediaHeights);

      if (tallest - shortest > HEIGHT_DIFFERENCE_THRESHOLD) {
        row.items.forEach((item) => item.classList.add(MIXED_CLASS));
      }
    });

    if (resizeObserver && !observedGrids.has(grid)) {
      resizeObserver.observe(grid);
      observedGrids.add(grid);
    }
  }

  function updateAllGrids() {
    document.querySelectorAll(GRID_SELECTOR).forEach(updateGrid);
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  document.addEventListener(
    'load',
    (event) => {
      if (event.target instanceof HTMLImageElement && event.target.closest(GRID_SELECTOR)) {
        scheduleUpdate();
      }
    },
    true
  );
  document.addEventListener('shopify:section:load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  const mutationObserver = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(GRID_SELECTOR) || node.querySelector?.(GRID_SELECTOR))
        )
      )
    ) {
      scheduleUpdate();
    }
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  scheduleUpdate();
})();
